import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';
/**
 * 募集要項下部「写真をもっと見る」click計測.
 */
export const measureClickPublicationPhotoLink = () => {
  // カスタムリンク
  tl('Tgenkou_photo_jobdescription_morepic_click', {});
};
